import { Day } from './Day';
import { chunk } from './utils/array';
import { getDays } from './utils/getDays';
import { getDayNames } from './utils/getDayNames';
import { createElement } from './utils/dom';
import { monthNames, weekdayNames } from './constants';

export function Month(month, config) {
	let { fixedWeeks, weekStartsOn } = config;

	let dates = getDays(month, weekStartsOn, fixedWeeks);
	let days = dates.map(date => Day(date, month, config));

	function render() {
		let header = createElement('div');
		let wrapper = createElement('div');
		let table = createElement('table');

		header.className = config.classes.header;
		wrapper.className = config.classes.month;

		table.setAttribute('role', 'grid');
		header.textContent = formatCaption(month);

		let head = createHead(weekStartsOn);

		let rows = chunk(days, 7).map(week => {
			let row = createElement('tr');
			row.className = config.classes.week;
			row.append(...week.map(day => day.render()));

			return row;
		});

		table.append(head, ...rows);
		wrapper.append(header, table);

		return wrapper;
	}

	function formatCaption(date) {
		return `${monthNames[date.getMonth()]} ${date.getFullYear()}`;
	}

	function createHead(weekStartsOn) {
		let row = createElement('tr');
		let head = createElement('thead');

		getDayNames(weekdayNames, weekStartsOn).forEach(day => {
			let th = createElement('th');
			th.scope = 'col';
			th.textContent = day;
			th.className = config.classes.dayName;
			row.append(th);
		});

		head.append(row);

		return head;
	}

	return {
		days,
		month,
		render,
	};
}
